import React, { memo } from "react";
import {
  MobileDateTimePicker,
  MobileDateTimePickerProps,
  LocalizationProvider,
} from "@material-ui/pickers";
import useAppDatePicker from "./index.hooks";
import * as adapter from "@material-ui/pickers/adapter/moment";
import { AppTextField } from "components/index";
import { Control, Controller } from "react-hook-form";
import { Moment } from "moment";

type AppDatePickerProps = {
  name?: string;
  error?: boolean;
  defaultValue?: Moment;
  helperText?: string;
  control?: Control;
  textFieldRef?: React.MutableRefObject<HTMLInputElement>;
} & Omit<MobileDateTimePickerProps, "renderInput" | "onChange" | "value">;

const AppDatePicker = ({
  error,
  helperText,
  textFieldRef,
  defaultValue,
  name,
  control,
  ...props
}: AppDatePickerProps) => {
  const { styles, classes, atomicStyles } = useAppDatePicker();

  return (
    <LocalizationProvider dateAdapter={adapter.default}>
      <Controller
        name={name}
        control={control}
        render={({ name, value, ref, onBlur, onChange }) => (
          <MobileDateTimePicker
            value={value ?? defaultValue}
            onChange={(date) => onChange(date)}
            renderInput={(textFieldProps) => {
              const {
                error: err,
                helperText: help,
                ...otherProps
              } = textFieldProps;
              return (
                <AppTextField
                  name={name}
                  fullWidth
                  className={styles.dateInputField}
                  defaultValue={defaultValue}
                  inputRef={(e) => {
                    ref.current = e;
                    if (textFieldRef) {
                      textFieldRef.current = e;
                    }
                  }}
                  onBlur={onBlur}
                  error={error}
                  helperText={helperText}
                  {...otherProps}
                />
              );
            }}
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default memo(AppDatePicker);
